import { Chip } from '@mui/material';
import ObjectPicker from 'application/Shared/Components/Pickers/Components/ObjectPicker';
import i18n from 'i18n';
import React, { useLayoutEffect, useState } from 'react';

const VisualOnlyDefault = () => (
    <Chip size="small" variant="outlined" label="Yellow" />
);

const TagColorOptions = [
    {
        display: i18n.t('Tags.color.option1'),
        displayVisualOnly: (
            <Chip
                variant="whiteText"
                size="small"
                label={i18n.t('Tags.color.option1')}
                sx={{
                    '& .MuiChip-label': {
                        paddingX: '8px',
                        paddingY: '2px'
                    },
                    backgroundColor: 'tag.option1'
                }}
            />
        ),
        id: 'tag.option1'
    },
    {
        display: i18n.t('Tags.color.option2'),
        displayVisualOnly: (
            <Chip
                variant="whiteText"
                size="small"
                label={i18n.t('Tags.color.option2')}
                sx={{
                    '& .MuiChip-label': {
                        paddingX: '8px',
                        paddingY: '2px'
                    },
                    backgroundColor: 'tag.option2'
                }}
            />
        ),
        id: 'tag.option2'
    },
    {
        display: i18n.t('Tags.color.option3'),
        displayVisualOnly: (
            <Chip
                variant="whiteText"
                size="small"
                label={i18n.t('Tags.color.option3')}
                sx={{
                    '& .MuiChip-label': {
                        paddingX: '8px',
                        paddingY: '2px'
                    },
                    backgroundColor: 'tag.option3'
                }}
            />
        ),
        id: 'tag.option3'
    },
    {
        display: i18n.t('Tags.color.option4'),
        displayVisualOnly: (
            <Chip
                variant="whiteText"
                size="small"
                label={i18n.t('Tags.color.option4')}
                sx={{
                    '& .MuiChip-label': {
                        paddingX: '8px',
                        paddingY: '2px'
                    },
                    backgroundColor: 'tag.option4'
                }}
            />
        ),
        id: 'tag.option4'
    },
    {
        display: i18n.t('Tags.color.option5'),
        displayVisualOnly: (
            <Chip
                variant="whiteText"
                size="small"
                label={i18n.t('Tags.color.option5')}
                sx={{
                    '& .MuiChip-label': {
                        paddingX: '8px',
                        paddingY: '2px'
                    },
                    backgroundColor: 'tag.option5'
                }}
            />
        ),
        id: 'tag.option5'
    },
    {
        display: i18n.t('Tags.color.option6'),
        displayVisualOnly: (
            <Chip
                variant="whiteText"
                size="small"
                label={i18n.t('Tags.color.option6')}
                sx={{
                    '& .MuiChip-label': {
                        paddingX: '8px',
                        paddingY: '2px'
                    },
                    backgroundColor: 'tag.option6'
                }}
            />
        ),
        id: 'tag.option6'
    },
    {
        display: i18n.t('Tags.color.option7'),
        displayVisualOnly: (
            <Chip
                variant="whiteText"
                size="small"
                label={i18n.t('Tags.color.option7')}
                sx={{
                    '& .MuiChip-label': {
                        paddingX: '8px',
                        paddingY: '2px'
                    },
                    backgroundColor: 'tag.option7'
                }}
            />
        ),
        id: 'tag.option7'
    },
    {
        display: i18n.t('Tags.color.option8'),
        displayVisualOnly: (
            <Chip
                variant="whiteText"
                size="small"
                label={i18n.t('Tags.color.option8')}
                sx={{
                    '& .MuiChip-label': {
                        paddingX: '8px',
                        paddingY: '2px'
                    },
                    backgroundColor: 'tag.option8'
                }}
            />
        ),
        id: 'tag.option8'
    }
];

// Taken from this SO post
// https://stackoverflow.com/questions/48484767/javascript-check-if-string-is-valid-css-color
const isColor = (strColor) => {
    const s = new Option().style;
    s.color = strColor;
    return s.color !== '';
};

/**
 * Builds a list of selectable options for the color picker.
 * In the past, some of our old tags have HEX colors, but our new tags will have values like
 * `"tag.option1"` as the color. For cases where the color is a HEX, we want to check if it's a
 * valid color and add to the list of selectable options.
 * @param {string} incomingValue
 * @returns {Array}
 */
const buildColorOptions = (incomingValue) => {
    const isListedColorOption = TagColorOptions.some(
        (color) => color.id === incomingValue
    );

    const isValidColor = isListedColorOption || isColor(incomingValue);

    const options = [...TagColorOptions];
    if (!isListedColorOption && isValidColor) {
        options.push({
            display: incomingValue,
            displayVisualOnly: (
                <Chip
                    variant="whiteText"
                    size="small"
                    label={incomingValue}
                    sx={{
                        '& .MuiChip-label': {
                            paddingX: '8px',
                            paddingY: '2px'
                        },
                        backgroundColor: incomingValue
                    }}
                />
            ),
            id: incomingValue
        });
    }

    return options;
};

const ColorPicker = (props) => {
    const [colorOptions, setColorOptions] = useState([]);

    // We only want to build the list of colors on initial render so that if a custom color was previously used,
    // it will remain as an option if the user changes off of that color.
    useLayoutEffect(() => {
        setColorOptions(buildColorOptions(props.value));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ObjectPicker
            {...props}
            disableClearable
            objectPayload={colorOptions}
            objectNameField="display"
            objectNameFieldVisualOnly="displayVisualOnly"
            visualOnlyDefault={<VisualOnlyDefault />}
        />
    );
};

export default ColorPicker;
